'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _sharedProbeLogo = require('@bibliocommons/shared-probe-logo');

var _sharedProbeLogo2 = _interopRequireDefault(_sharedProbeLogo);

var _baseIcons = require('@bibliocommons/base-icons');

require('../styles/SearchProbe.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchProbe = function SearchProbe(_ref) {
  var searchUrl = _ref.searchUrl,
      libraryName = _ref.libraryName,
      count = _ref.count,
      siteId = _ref.siteId;
  return count > 0 ? _react2.default.createElement(
    'div',
    { className: 'cp-search-probe' },
    _react2.default.createElement(
      'div',
      { className: 'cp-avatar' },
      _react2.default.createElement(_sharedProbeLogo2.default, { className: 'library-logo', siteId: siteId, small: true, circled: true })
    ),
    _react2.default.createElement(
      'a',
      { href: searchUrl, target: '_blank', rel: 'noopener noreferrer', className: 'search-probe-link' },
      _react2.default.createElement(
        'div',
        { className: 'library-name' },
        libraryName,
        '\xA0',
        _react2.default.createElement(_baseIcons.Arrows.long.Right, { color: '#333' })
      ),
      _react2.default.createElement(
        _reactIntl.FormattedMessage,
        { id: 'searchProbeCount', values: { count: count } },
        function (message) {
          return _react2.default.createElement(
            'div',
            { className: 'result-count' },
            message
          );
        }
      )
    )
  ) : null;
};

SearchProbe.propTypes = {
  siteId: _react.PropTypes.string.isRequired,
  libraryName: _react.PropTypes.string.isRequired,
  count: _react.PropTypes.number,
  searchUrl: _react.PropTypes.string.isRequired
};

exports.default = SearchProbe;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/probes/lib/components/search-probe/components/SearchProbe.component.js
// module id = 1456
// module chunks = 1